import React from 'react';
import {StyleSheetManager as StyleSheetManagerBase} from 'styled-components';
import rtlPlugin from 'stylis-plugin-rtl';

/**
 * The plugin needs a name to be able to remove it from the stylis cache.
 */
Object.defineProperty(rtlPlugin, 'name', {value: 'stylisRTLPlugin'});

export const StyleSheetManager: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  return (
    <StyleSheetManagerBase stylisPlugins={[rtlPlugin as any]}>
      {children}
    </StyleSheetManagerBase>
  );
};
